import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-brand-black px-4 py-20 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-60">
      <div className="mx-auto max-w-3xl text-center" data-id="element-61">
        <ShieldCheckIcon className="mx-auto mb-6 h-20 w-20 text-brand-green" data-id="element-62" />

        <h2 className="mb-6 text-3xl font-bold text-white sm:text-4xl" data-id="element-63">
          Garantía Total de 7 Días
        </h2>

        <p className="mb-8 text-xl font-bold text-brand-green" data-id="element-64">
          El riesgo es completamente nuestro.
        </p>

        <div className="space-y-6 text-lg text-gray-300" data-id="element-65">
          <p data-id="element-66">
            Descarga el sistema completo hoy. Aplica al menos uno de los métodos
            en tus chats. Si en 7 días no ves una diferencia real en tus
            conversaciones de venta, te devolvemos el 100% de tu dinero.
          </p>
          <p data-id="element-67">Sin preguntas. Sin formularios complicados. Sin demoras.</p>
          <p className="text-xl font-bold text-white italic mt-8" data-id="element-68">
            "La única forma de perder es no intentarlo."
          </p>
        </div>
      </div>
    </section>;
}